<svelte:head>
  <title>{data?.title || 'Need'} | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-missing-attribute -->

<div class="block is-size-7">
  <a href={$url('../../../needs')}> &lt; Back to needs</a>
</div>

{#if data}

  <nav class="level">
    <div class="level-left level-can-wrap">
      <div class="level-item level-can-wrap">
        <h2 class="title">
          {data.title || '<No title>'} <span class="tag is-info is-small">{data.status}</span>
        </h2>
      </div>
    </div>

    <!-- Right side -->
    <div class="level-right">
      <button class="button" on:click={() => $goto('../edit')}> Edit </button>
      &nbsp;

      {#if charity}
        <a
          class="button"
          href={$url('../../../business', {
            filter_postcode: data.location.postcode,
          })}
        >
          Show nearby businesses
        </a>
        &nbsp;
      {/if}

      {#if data.status === 'pending-approval'}
        <button
          class="button is-primary"
          on:click={() =>
            ($uiState.activeModal = {
              component: ConfirmApprove,
              props: { item: { id, data } },
            })}
        >
          Approve
        </button>
        &nbsp;
      {/if}

      {#if data.status === 'published'}
        <button
          class="button"
          on:click={() => {
            $uiState.activeModal = {
              component: ConfirmEnd,
              props: { item: { id, data } },
            };
          }}
        >
          End need
        </button>
        &nbsp;
      {/if}

      {#if data.status === 'draft'}
        <button
          class="button"
          on:click={() => {
            $uiState.activeModal = {
              component: ConfirmDelete,
              props: { item: { data: data, id }, navPath },
            };
          }}
        >
          Delete
        </button>
      {/if}
    </div>
  </nav>

  <div class="columns">

    <div class="column">

      {#if data.status === 'published'}
        <article class="message is-success">
          <div class="message-body">
            <p class="block">This need is live! Public link:
              <a href="{$appState.origin}/public/needs/need/{id}"
                >{$appState.origin}/public/needs/need/{id}</a
              >
            </p>
          </div>
        </article>
      {/if}
    
      {#if data.status === 'ended'}
        <article class="message is-success">
          <div class="message-body">
            <p class="block">This need has ended.</p>
          </div>
        </article>
      {/if}

      {#if createdDatePhrase}
        <div class="block has-text-grey-light">
          Published {createdDatePhrase}
        </div>
      {/if}

      {#if data.location.postcode}
        <div class="block">
          {#if data.location.postcode}
            <span class="tag is-light is-small">{data.location.postcode}</span>
          {/if}
        </div>
      {/if}

      <p class="block" style="white-space:pre-wrap;">{data.needs}</p>

      <p class="block" style="white-space:pre-wrap;">{data.benefits}</p>

      <p class="block" style="white-space:pre-wrap;">{data.background}</p>

    </div>
    <div class="column is-narrow">
      {#if data.images?.[0]}
        <img
          alt="Offer"
          on:click={() => {
            $uiState.activeModal = {
              component: Lightbox,
              props: { images: data.images, index: 0 },
            };
          }}
          src={data.images[0]}
          style="width:240px; cursor:pointer;"
        />
      {:else}
        <img
          alt="Generic"
          src="/assets/img/box.png"
          style="height:240px;width:240px; background-color:lightgrey"
        />
      {/if}
      <div style="width:250px;">
        {#if data.images && data.images.length > 1}
          {#each data.images as url, index}
            {#if index !== 0}
              <div style="display:inline-block;margin-right: 8px;">
                <img
                  alt="Offer"
                  on:click={() => {
                    $uiState.activeModal = {
                      component: Lightbox,
                      props: { images: data.images, index },
                    };
                  }}
                  src={url}
                  style="max-width:116px;"
                />
              </div>
            {/if}
          {/each}
        {/if}
      </div>
    </div>
  </div>

  {#if charity}
    <div class="box">
      <p class="is-size-4">Charity details</p>
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th style="width:200px" />
            <th />
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Name</td>
            <td
              ><a href={$url('../../../charity/' + data.charity)}
                >{charity.name}</a
              ></td
            >
          </tr>
          <tr>
            <td>Postcode</td>
            <td>
              {charity.contact.postcode}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  {/if}
  {#if contact}
    <div class="box">
      <p class="is-size-4">Contact details</p>
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th style="width:200px" />
            <th />
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Name</td>
            <td>
              {contact.data.firstName}
              {contact.data.lastName}
            </td>
          </tr>
          <tr>
            <td>Email</td>
            <td>{contact.id}</td>
          </tr>
        </tbody>
      </table>
    </div>
  {/if}
  

  <hr />
  <h2 class="is-size-4">Responses</h2>
  <table class="table is-hoverable">
    <colgroup>
      <col span="1" style="width: 20%;" />
      <col span="1" style="width: 80%;" />
    </colgroup>
    <tbody>
      {#if responses}
        {#each responses as response}
          <tr>
            <td>
              <span>
                <a href={$url('../../../business/' + response.data.company.id)}>
                  {response.data.company.name}
                </a>
              </span>
            </td>
            <td>
              {#if response.data.message}
                <Message>
                  {response.data.message}
                </Message>
              {/if}
            </td>
            <td>
              {#if response.data.created}
                <span
                  style="white-space:nowrap;"
                  class="has-text-grey-light">
                  {dayjs().to(response.data.created)}
                </span>
              {/if}
            </td>
          </tr>
        {/each}
      {/if}
    </tbody>
  </table>

  {#if !responses || responses.length == 0}
    <div class="block has-text-grey-light">
      Waiting for the first response for this need.
    </div>
  {/if}

{/if}

<script lang="ts">
  export let id: string;
  import _ from 'lodash';
  import { appState } from '../../../../lib/appState';
  import { uiState } from '../../../../lib/uiState';
  import { goto, url } from '@sveltech/routify';

  import Lightbox from '../../../_components/Lightbox.svelte';
  import ConfirmApprove from '../../needs/_components/ConfirmApprove.svelte';
  import ConfirmEnd from './_components/ConfirmEnd.svelte';
  import Message from '../../../_components/Message.svelte';
  import dayjs from 'dayjs';
  import relativeTime from 'dayjs/plugin/relativeTime';
  import ConfirmDelete from '../../../business/offer/[id]/_components/ConfirmDelete.svelte';

  dayjs.extend(relativeTime);

  let data: Need_v1;

  let charity: Charity_v2;
  let contact: User_v1_Doc;
  let responses: NeedResponse_v1_Doc[];

  let firebase = window.firebase;

  const navPath = '/admin/needs/draft';

  $: createdDatePhrase = data?.created ? dayjs().to(data.created) : undefined;

  get();
  getResponses();

  $: if (data) getCharity(data.charity);

  $: if (data) getContact(data.charity);

  async function get() {
    firebase
      .firestore()
      .collection('needs_v1')
      .doc(id)
      .onSnapshot((doc) => {
        data = doc.data() as Need_v1;
      });
  }

  async function getCharity(charityId: CharityId) {
    firebase
      .firestore()
      .collection('charities_v2')
      .doc(charityId)
      .onSnapshot((doc) => {
        charity = doc.data() as Charity_v2;
      });
  }

  async function getContact(charityId: CharityId) {
    await firebase
      .firestore()
      .collection('users_v1')
      .where('charity', '==', charityId)
      .get()
      .then((docs) => {
        contact = { id: docs.docs[0].id, data: docs.docs[0].data() as User_v1 };
      });
  }

  async function getResponses() {
    firebase
      .firestore()
      .collection("need_responses_v1")
      .where("need", "==", id)
      .onSnapshot(async (result) => {
        if(!result.empty) {
          responses = result.docs.map(doc => {
            return {
              id: doc.id,
              data: doc.data() as NeedResponse_v1
            }
          });
        }
      });
  }
</script>
